import { Link } from "react-router-dom";
import { Avatar, Group, Paper, Stack, Text } from "@mantine/core";
import { getPodcastImage, ImageSizes } from "@/core/helpers";

export function TinyPodcasListItem({ podcast }: { podcast: Podcast }) {
    return (
        <Paper component={Link} p="sm" radius="sm" shadow="xs" to={`/podd/${podcast.slug}`} withBorder>
            <Group gap="sm" wrap="nowrap">
                <Avatar radius="sm" size={50} src={getPodcastImage(podcast, ImageSizes.Thumb)}>
                    {podcast.name.slice(0, 1)}
                </Avatar>
                <Stack gap={2} miw={0}>
                    <Text fw={600} lineClamp={2} size="sm">
                        {podcast.name}
                    </Text>
                    <Text c="dimmed" size="xs">
                        {podcast.author.name}
                    </Text>
                </Stack>
            </Group>
        </Paper>
    );
}
